import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Page } from '../models/page';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getPageBySlug(slug: string): Observable<Page> {
    return this.httpClient.get<Page>("pages/" + slug);
  }
}
